import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as expertInquirySelectors from "@rentiohq/shared-frontend/dist/redux/expertInquiry/expertInquiry.selectors";
import * as contractHooks from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.hooks";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { IRentDeposit } from "@rentiohq/shared-frontend/dist/types/rentDeposit.types";
import { useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";
import { EAdministrationItems } from "../AdministrationItems/AdministrationItems.types";
import {
  //   getRentioMoveServiceForExitMessage,
  getOutstandingPaymentOrderMessage,
  getOutgoingPropertyInspectionReportMessage,
  getRentDepositReleaseMessage,
} from "./../../ContractCard.utils";

export const useGetExitChecklistItems = (params: {
  contract: IContract;
  property: IProperty;
  rentDeposits?: IRentDeposit[];
  isFetchingRentDeposits?: boolean;
  paymentOrdersCount?: number;
  isFetchingPaymentOrdersCount?: boolean;

  // Callbacks
  onShowRentDeposit: (rentDepositId: number) => void;
  onOrderPropertyInspectionReport: () => void;
  onCreateRentioMoveRequest: () => void;
  onShowMoveRequest: (moveRequestId: number) => void;

  // Config
}) => {
  const {
    contract,
    property,
    rentDeposits,
    isFetchingRentDeposits,
    paymentOrdersCount,
    isFetchingPaymentOrdersCount,
    onShowRentDeposit,
    onOrderPropertyInspectionReport,
    // onCreateRentioMoveRequest,
    // onShowMoveRequest,
  } = params;

  const { isBroker, broker } = authHooks.useSelf();

  const { update: updateContract } = contractHooks.useUpdate({
    id: contract.id,
  });

  // Property inspection report
  const partnerships = useSelector((state: IRootStore) =>
    expertInquirySelectors.partnerships(state),
  );

  //   const hasRentioMoveServiceForBroker = brokerHooks.useBrokerFeature(
  //     EBrokerFeature.RentioMove,
  //   );

  // Build checklist items
  const checklistItems = {
    [EAdministrationItems.DepositRelease]: getRentDepositReleaseMessage({
      property,
      contract,

      // Callbacks
      onShowRentDeposit,

      // Actions
      updateContract,

      // Config
      rentDeposit: rentDeposits?.[0],
      isFetchingRentDeposit: isFetchingRentDeposits || false,
    }),
    [EAdministrationItems.OutstandingPayments]:
      getOutstandingPaymentOrderMessage({
        property,
        contract,

        // Actions
        updateContract,

        // Config
        isBroker,
        paymentOrdersCount,
        isFetchingPaymentOrdersCount: isFetchingPaymentOrdersCount || false,
      }),
    [EAdministrationItems.OutgoingPropertyInspectionReport]:
      getOutgoingPropertyInspectionReportMessage({
        property,
        contract,
        isBroker,
        broker,

        // Callbacks
        onOrderPropertyInspectionReport,

        // Actions
        updateContract,

        // Config
        partnerships,
      }),
    // ...(hasRentioMoveServiceForBroker || Boolean(contract.rentioMoveStatus)
    //   ? {
    //       [EAdministrationItems.OutgoingMove]: getRentioMoveServiceForExitMessage({
    //         property,
    //         contract,

    //         // Callbacks
    //         onCreateRentioMoveRequest,
    //         onShowMoveRequest,

    //         // Actions
    //         updateContract,

    //         // Config
    //         isBroker,
    //         hasRentioMoveServiceForBroker,
    //         internalModeEnabled,
    //       }),
    //     }
    //   : {}),
  };

  return Object.fromEntries(
    Object.entries(checklistItems).filter(([_, value]) => Boolean(value)),
  );
};
